import { useAppDispatch } from '@/shared/hooks';

import { assetsModel } from '@/entities/assets';

export const useRemoveAsset = () => {
  const dispatch = useAppDispatch();

  return async (assetID: string) => {
    await dispatch(assetsModel.thunks.deleteAsset({ AssetID: assetID }));
  };
};
